<template lang="pug">
	.elements-add(v-show="showed" :style="position" v-pseudo-modal-name="'elements-add'")
		MultiLevelDropdownMenu(ref="dropdownMenu" @change="addElement($event.item, $event.data)")
</template>

<script>
	import Screen from './../../mixins/screen'

	import MultiLevelDropdownMenu from './../UI/MultiLevelDropdownMenu'

	export default {
		name: 'EditorElementAdd',
		mixins: [Screen],
		screen: {
			updateOn: [
			],
			events: {
				"Show EditorElementAdd": function(el, element) {

					this.element = element;

					let rect = el.getBoundingClientRect();

					this.position.right = (document.body.clientWidth - rect.right) + 'px';
					this.position.bottom = (document.body.clientHeight - rect.bottom) + 'px';

				},
				// Клик в любом месте кроме контента помеченного element-add - закрывает компонент
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'elements-add') && this.showed) {

						this.close();

					}

				}
			}
		},
		components: {
			MultiLevelDropdownMenu
		},
		props: [],
		data() {
			return {
				position: {
					right: 0,
					bottom: 0
				}
			};
		},
		methods: {
			collectData() {

				let imageAssets = _.filter(Asset.getVersionAssets(Version.SelectedVersion), asset => asset.type === 'image');

				let imageItem = {title: 'Image', width: 200, opened: false, icon: 'fa-image', childs: [
					{title: 'Upload new image', description: 'Add new image from your device', width: 200, icon: 'fa-upload', action: 'upload-asset', assetType: 'image', data: {}},
					{title: 'Use existing image', width: 200, opened: false, childs: _.map(imageAssets, asset => {
						return {title: asset.codename, width: 200, icon: 'fa-image', action: 'add-image', data: {assetCodename: asset.codename}}}
					)},
					{title: 'Primitives', width: 200, opened: false, disabled: true, childs: []},
					{title: `Add image from library`, width: 200, disabled: true},
					{title: 'Generate image using AI', description: 'Create a new image and element using AI', width: 200, icon: 'fa-magic', action: 'generate-image', data: {}}
				]};

				let videoAssets = _.filter(Asset.getVersionAssets(Version.SelectedVersion), asset => asset.type === 'video');

				let videoItem = {title: 'Video', width: 200, opened: false, icon: 'fa-video-camera', childs: [
					{title: 'Upload new video file', description: 'Add new video from your device', width: 200, icon: 'fa-upload', action: 'upload-asset', assetType: 'video', data: {}},
					{title: 'Use existing video', width: 200, opened: false, childs: _.map(videoAssets, asset => {
						return {title: asset.codename, width: 200, icon: 'fa-video-camera', action: 'add-video', data: {assetCodename: asset.codename}}}
					)},
					{title: `Add video from library`, width: 200, disabled: true},
					{title: 'Generate video using AI', description: 'Create a new video and element using AI', width: 200, icon: 'fa-magic', action: 'generate-video', data: {}}
				]};

				let messages = Localization.getVersionLocalization(Version.SelectedVersion).en;

				let textItem = {title: 'Text', width: 250, opened: false, icon: 'fa-font', childs: [
					{title: 'Create new text', description: 'Add new text to the scene', width: 200, icon: 'fa-font', action: 'create-text', inlineRequestText: true, data: {}},
					{title: 'Use existing text', width: 200, opened: false, childs: _.map(messages, message => {
						return {title: message.codename, width: 200, icon: 'fa-font', action: 'add-text', data: {localizationCodename: message.codename}}}
					)}
				]};

				let spineAssets = _.filter(Asset.getVersionAssets(Version.SelectedVersion), asset => asset.type === 'spine');

				// Новый Spine загружается тремя файлами (json + atlas + png) - см. MultiLevelDropdownMenu.uploadAsset
				let spineItem = {title: 'Spine', description: 'Add Spine animation', width: 200, opened: false, icon: 'fa-child', childs: [
					{title: 'Upload new Spine', description: 'Select json + atlas + png files of the Spine animation', width: 200, icon: 'fa-upload', action: 'upload-asset', assetType: 'spine', data: {}},
					{title: 'Use existing Spine', width: 200, opened: false, childs: _.map(spineAssets, asset => {
						return {title: asset.codename, width: 200, icon: 'fa-child', action: 'add-spine', data: {assetCodename: asset.codename}}}
					)},
					{title: `Add Spine from library`, width: 200, disabled: true},
					{title: 'Generate Spine using AI', width: 200, disabled: true}
				]};

				// Спрайтовые анимации - атласы с пометкой spritesAnimation (кадры, спрайт-лист или json атласа загружаются сразу набором файлов)
				let spriteAnimationAssets = _.filter(Asset.getVersionAssets(Version.SelectedVersion), asset => asset.type === 'atlas' && asset.options?.spritesAnimation);

				let spriteAnimationItem = {title: 'Sprite animation', description: 'Add sprite animation', width: 200, opened: false, icon: 'fa-film', childs: [
					{title: 'Upload new sprite animation', description: 'Select frame images, a sprite sheet or an atlas json + texture', width: 200, icon: 'fa-upload', action: 'upload-asset', assetType: 'sprite-animation', data: {}},
					{title: 'Use existing sprite animation', width: 200, opened: false, childs: _.map(spriteAnimationAssets, asset => {
						return {title: asset.codename, width: 200, icon: 'fa-film', action: 'add-sprite-animation', data: {assetCodename: asset.codename}}}
					)},
					{title: `Add sprite animation from library`, width: 200, disabled: true},
					{title: 'Generate sprite animation using AI', width: 200, disabled: true}
				]};

				let animationItem = {title: 'Animation', width: 200, opened: false, icon: 'fa-film', childs: [
					{title: 'Gif', description: 'Upload animated gif image', width: 200, disabled: true, icon: 'fa-video-camera'},
					spineItem,
					spriteAnimationItem,
					{title: 'After Effects', description: 'Add Lottie animation', width: 200, disabled: true, icon: 'fa-video-camera'}
				]};

				let structureItem = {title: 'Structure', width: 200, opened: false, icon: 'fa-folder', childs: [
					{title: 'Group', description: 'Add group to combine several items together', width: 200, icon: 'fa-folder', action: 'create-group'},
					{title: 'Field', description: 'Add 3x3 groups field or line', width: 200, disabled: true, icon: 'fa-folder'}
				]};

				let eventItemsTree = [
					imageItem,
					textItem,
					videoItem,
					animationItem,
					structureItem
				];

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.setItems(eventItemsTree);

			},
			addElement(item, data) {

				if (item.action === 'upload-asset' && item.assetType === 'image') this.createElementTypeImage(data.assetCodename);
				else if (item.action === 'add-image') this.createElementTypeImage(data.assetCodename);

				else if (item.action === 'create-text') this.addLocalization(data.inlineText);
				else if (item.action === 'add-text') this.createElementTypeText(data.localizationCodename);

				else if (item.action === 'upload-asset' && item.assetType === 'video') this.createElementTypeVideo(data.assetCodename);
				else if (item.action === 'add-video') this.createElementTypeVideo(data.assetCodename);

				// Генерация с нуля: при первой генерации создаются и ассет, и элемент
				else if (item.action === 'generate-image') this.generateAsset('image');
				else if (item.action === 'generate-video') this.generateAsset('video');

				else if (item.action === 'upload-asset' && item.assetType === 'spine') this.createElementTypeSpine(data.assetCodename);
				else if (item.action === 'add-spine') this.createElementTypeSpine(data.assetCodename);

				else if (item.action === 'upload-asset' && item.assetType === 'sprite-animation') this.createElementTypeSpriteAnimation(data.assetCodename);
				else if (item.action === 'add-sprite-animation') this.createElementTypeSpriteAnimation(data.assetCodename);

				else if (item.action === 'create-group') this.createElementTypeGroup();

				this.close();

			},
			createElementTypeImage(assetCodename) {

				Server.sendToServer({
					CreateElement: {
						versionId: Version.SelectedVersion.id,
						screenId: ScreenService.SelectedScreen.id,
						elementId: Elements.SelectedElement?.id || 0,
						elementCodename: 'image',
						newElementCodename: assetCodename.split('.')[0],
						newElementProps: {
							image: assetCodename
						}
					}
				});

			},
			createElementTypeVideo(assetCodename) {

				Server.sendToServer({
					CreateElement: {
						versionId: Version.SelectedVersion.id,
						screenId: ScreenService.SelectedScreen.id,
						elementId: Elements.SelectedElement?.id || 0,
						elementCodename: 'video',
						newElementCodename: assetCodename.split('.')[0],
						newElementProps: {
							video: assetCodename
						}
					}
				});

			},
			createElementTypeSpine(assetCodename) {

				Server.sendToServer({
					CreateElement: {
						versionId: Version.SelectedVersion.id,
						screenId: ScreenService.SelectedScreen.id,
						elementId: Elements.SelectedElement?.id || 0,
						elementCodename: 'spine',
						newElementCodename: assetCodename.split('.')[0],
						newElementProps: {
							spine: assetCodename
						}
					}
				});

			},
			createElementTypeSpriteAnimation(assetCodename) {

				Server.sendToServer({
					CreateElement: {
						versionId: Version.SelectedVersion.id,
						screenId: ScreenService.SelectedScreen.id,
						elementId: Elements.SelectedElement?.id || 0,
						elementCodename: 'sprite-animation',
						newElementCodename: assetCodename.split('.')[0],
						newElementProps: {
							spriteAnimation: assetCodename,
							// Спрайтовая анимация создаётся с бесконечным повтором, а проигрывание запускается событием Created (экшен play-animation)
							loop: 'infinity'
						}
					}
				});

			},
			addLocalization(text) {

				if (!text) return;

				Server.sendToSocket({
					CreateLocalizationMessage: {
						versionId: Version.SelectedVersion.id,
						locale: 'en',
						message: text
					}
				});

				Broadcast.once("Selected Version Localization Changed", (versionId, locale, localizationCodename) => {

					this.createElementTypeText(localizationCodename);

					this.close();

				}, "Dropdown Editor Element Add");

			},
			createElementTypeText(localizationCodename) {

				Server.sendToServer({
					CreateElement: {
						versionId: Version.SelectedVersion.id,
						screenId: ScreenService.SelectedScreen.id,
						elementId: Elements.SelectedElement?.id || 0,
						elementCodename: 'text',
						newElementCodename: localizationCodename.split('.')[0],
						newElementProps: {
							text: localizationCodename
						}
					}
				});

			},
			createElementTypeGroup() {

				Server.sendToServer({
					CreateElement: {
						versionId: Version.SelectedVersion.id,
						screenId: ScreenService.SelectedScreen.id,
						elementId: Elements.SelectedElement?.id || 0,
						elementCodename: 'container',
						newElementCodename: 'group',
						newElementProps: {}
					}
				});

			},
			// Открывает экран генерации картинки или видео без ассета: при первой генерации
			// на сервере создаются и ассет, и элемент в текущем экране (см. resolveGenerationAsset)
			generateAsset(assetType) {

				let options = {
					versionId: Version.SelectedVersion.id,
					newElementType: assetType,
					elementScreenCodename: ScreenService.SelectedScreen.codename,
					parentElementId: Elements.SelectedElement?.id || 0
				};

				if (assetType === 'video') Broadcast.call("Show AssetVideoGeneration", [null, options]);
				else Broadcast.call("Show AssetImageGeneration", [null, options]);

			},
			close() {

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.close();

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.elements-add
		position: absolute
		margin-top: 1px
		user-select: none

</style>
